import { ApiSubUrls, Apis } from 'enums/api-constants'
import { NoteItem } from 'pages/notes/note-types'
import { NotesData } from 'pages/notes/utils/notes'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchNotes = fetchGeneralData<NotesData>(
    `${ApiSubUrls[Apis.NOTES]}`,
)
export const addNoteItem = fetchGeneralData<NotesData, NoteItem>(
    `${ApiSubUrls[Apis.NOTES]}`,
)
export const updateNoteItem = fetchGeneralData<NotesData, NoteItem>(
    `${ApiSubUrls[Apis.NOTES]}`,
)
